import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "../../components/ui/common/dialog";
import {
  mappingDialogContentClass,
  mappingDialogHeaderClass
} from "./mappingModalStyles";

interface DrawingErrorsModalProps {
  errors: string[];
  setPutDataToQueueErrors: (errors: string[]) => void;
}

const DrawingErrorsModal = ({
  errors,
  setPutDataToQueueErrors
}: DrawingErrorsModalProps) => {
  const onClose = () => {
    setPutDataToQueueErrors([]);
  };

  return (
    <Dialog open={errors.length > 0} onOpenChange={open => !open && onClose()}>
      <DialogContent className={mappingDialogContentClass}>
        <DialogHeader className={mappingDialogHeaderClass}>
          <DialogTitle>Mapping Errors!</DialogTitle>
        </DialogHeader>

        <ul className="tw-m-0 tw-max-h-80 tw-list-none tw-space-y-2 tw-overflow-y-auto tw-p-0">
          {errors.map((error: string, index: number) => (
            <li
              key={`error-${index}`}
              className="tw-rounded-md tw-border tw-border-destructive/20 tw-bg-destructive/5 tw-px-3 tw-py-2 tw-text-sm tw-text-destructive"
            >
              {error}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};

export default DrawingErrorsModal;
